import styled from 'styled-components';

export const StyledSearchResultWrapper = styled.div`
    @media (max-width: 768px) {
        padding-bottom: 100px;
    }
`;

export const StyledSearchSectionSpacer = styled.div`
    width: 100%;
    height: 10px;
    &:last-of-type {
        height: 0;
    }
`;
